export const API_REPORTS_ANALYTICS_DETAILS_INDEX = 'API_REPORTS_ANALYTICS_DETAILS_INDEX'

export const fetchReportAnalyticsDetails = (reportId: number) => ({
  type: API_REPORTS_ANALYTICS_DETAILS_INDEX,
  reportId,
})
